import { InputAdornment, InputLabel, Box } from '@mui/material';
import { useInput, useTranslate, Validator } from 'react-admin';
import SearchIcon from '@mui/icons-material/Search';
import { GoogleCoordinatesInput } from './GoogleCoordinatesInput';

export const GrayGoogleCoordinatesInputWithUpperLabel = (props: {
  source: string;
  label: string;
  placeholder: string;
  validate?: Validator[] | Validator;
  size?: 'small' | 'medium';
}) => {

  const translate = useTranslate();
  const { field } = useInput({ source: props.source, validate: props.validate });

  return (
    <>
      <InputLabel className="input-label">
        {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
      </InputLabel>
      <GoogleCoordinatesInput
        value={field.value}
        setValue={field.onChange}
        label={props.placeholder}
        variant="outlined"
        size={props.size}
        sx={{
          mt: 0,
          mb: 0,
          '& .MuiOutlinedInput-root': {
            borderRadius: '5px',
            backgroundColor: '#F2F2F2 !important',
            border: 'none',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          width: '50%',
        }}
        inputProps={{
          endAdornment: <InputAdornment position={'end'}><SearchIcon/></InputAdornment>,
        }}
      />
      {/* This box is needed to match the GoogleInput to other inputs from RA that have an about 20-px element below them */}
      <Box
        aria-hidden
        sx={{
          minHeight: '20px',
          margin: 0,
          padding: 0,
          pointerEvents: 'none',
        }}
      />
    </>
  );

};
